module.exports = __webpack_public_path__ + "static/img/1.fc5ba8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/eng/1.png
// module id = fnyH
// module chunks = 0